"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useStateMachine = require("./useStateMachine");
Object.keys(_useStateMachine).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useStateMachine[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useStateMachine[key];
    }
  });
});